export const walletConnectV2ProjectId = "df9eb73ffe200f2adf28bacf5f9f4793";
export const apiTimeout = 6000;
export const transactionSize = 10;
export const nativeAuth = true;
export const EGLD = "EGLD";
export const EGLD_DECIMALS = 18;
export const PULSAR_MONEY_DELEGATION =
  "erd1qqqqqqqqqqqqqqqpqqqqqqqqqqqqqqqqqqqqqqqqqqqqpg8llllsauamua";
export const HATOM_TOKEN = "HTM-f51d55";
export const SITE_URL = "https://beta.pulsar.money";
export const HIGH_TRAFFIC = false;
export const A1X_TOKEN = "A1X-0d446d";

// Solana Token Configuration
export const A1X_SOLANA_TOKEN = "mntCwvmSD2zjYNkF86hPYyDRyU3EdwT4cXwTkoVsPai"; // Solana token identifier for TradeSlvania API
export const A1X_MVX_TOKEN = A1X_TOKEN; // MultiversX token identifier for TradeSlvania API
export const A1X_MVX_DECIMALS = 18;
export const A1X_SOLANA_DECIMALS = 9;

// Solana RPC Configuration
export const SOLANA_RPC =
  "https://mainnet.helius-rpc.com/?api-key=17cef81f-c67e-4355-a098-eb52d101c2d9";

// Bridge Configuration
export const BRIDGE_NETWORKS = {
  SOLANA: "solana",
  MULTIVERSX: "multiversx",
} as const;

export const BRIDGE_ASSETS = {
  A1X: "A1X",
} as const;
